<!-- <div class="notification p-3">
  <h3 >Notification</h3>
  <div  class="inner-message overflow-auto">
    <mat-card class="d-flex card" *ngFor="let notification of notificationList" [class.border]="notification?.new">
      <mat-icon class="icon">account_circle</mat-icon><div class="ms-2 ps-3">{{notification?.desc}}.has sent u a rq</div></mat-card>
  </div>
  <div class="show-more text-center mt-3 border-top">
    <button mat-button (click)="goToIntimations()">
      Show more
    </button>
  </div>
</div> -->

<div class="notification-inner overflow-auto my-3">
  <div
    class="d-flex list-text"
    *ngFor="let notification of notificationList"
    [ngClass]="
      notification?.read ? 'list-text notification-read ' : 'border-list-text'
    "
  >
    <div class="text-center imageDisplay">
      <!-- <img src="./assets/images/userPic.png" class="img-fluid imageDisplay" /> -->
      <dg-file-upload
        class="uploadImage"
        [title]="profileAttachTitle"
        [profileAttachment]="isProfileComponent"
        [acceptedType]=""
        [maxSize]=""
        [uniqueAttachmentId]=""
        [allowFileToAttach]="isAllowFileToAttachProfile"
        [attachId]="notification?.attachId"
        [allowDelete]="isAllowDelete"
      >
      </dg-file-upload>
    </div>
    <div [ngClass]="notification?.read ? 'blur-list-text' : ' '">
      <p class="infoText mb-0">
        <a (click)="onClick(notification)">
          <strong>{{ notification?.desc }}</strong>
        </a>
        {{ notification?.description }}
      </p>
      <span class="dayText mt-2">{{ notification?.time }}</span>
    </div>
  </div>

  <!-- <div class="d-flex list-text ">
        <div class=" text-center w-25">
            <img src="./assets/images/profile.png" class="img-fluid">

        </div>
        <div>
            
            <p class="infoText mb-0">
                <strong>David John</strong>
                Has sent you a notificatio reg. approval of project

            </p>
            <span class="dayText">2 days ago</span>                    

        </div>
    </div>
    <div class="d-flex list-text ">
        <div class=" text-center w-25">
            <img src="./assets/images/profile.png" class="img-fluid">

        </div>
        <div>
            
            <p class="infoText mb-0">
                <strong>David John</strong>
                Has sent you a notificatio reg. approval of project

            </p>
            <span class="dayText">2 days ago</span>                    

        </div>
    </div> -->
</div>
